"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonInfo = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const SimpleButton_1 = tslib_1.__importDefault(require("../../../components/SimpleButton"));
const ButtonInfo = (props) => {
    return (React.createElement(SimpleButton_1.default, Object.assign({ "data-name": "info", iconSize: 20, icon: "info", variant: "raised", tone: "accent" }, props)));
};
exports.ButtonInfo = ButtonInfo;
